import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  COOKIE_SETTINGS,
  DEFAULT_COOKIE_SETTINGS,
} from '../constants';
import CookieManager from '../CookieManager';

import CookieNoticeLink from './CookieNoticeLink';
import CookieSettingsCheckbox from './CookieSettingsCheckbox';

class CookieSettingsPopup extends Component {
  constructor(props) {
    super(props);
    const {
      analytics,
      functionality,
    } = props;

    this.state = {
      analytics,
      functionality,
    };
  }

  handleChange = (name) => ({ target: { checked } }) => {
    this.setState({
      [name]: checked,
    });
  };

  handleSave = () => {
    const { onSave } = this.props;

    onSave({ ...this.state });
  };

  handleAllowAll = () => {
    this.setState({
      analytics: true,
      functionality: true,
    });
  };

  getVisibilitySettings = () => {
    const { storage } = this.props;

    return Object.values(COOKIE_SETTINGS).reduce((acc, setting) => ({
      ...acc,
      [setting]: DEFAULT_COOKIE_SETTINGS[storage.environment][setting][storage.isEuro ? 'EU' : 'NOT_EU'].visibility,
    }), {});
  };

  render() {
    const {
      lczStrings,
      disabledLinks,
      infoUrl,
      infoTarget,
      className,
    } = this.props;

    const {
      analytics,
      functionality,
    } = this.state;

    const popupClassName = `cookie-settings-popup ${className}`;
    const {
      [COOKIE_SETTINGS.ANALYTICS]: isAnalyticsVisible,
      [COOKIE_SETTINGS.FUNCTIONALITY]: isFunctionalityVisible,
    } = this.getVisibilitySettings();
    const enabledAllowAll = isFunctionalityVisible && isAnalyticsVisible && !(functionality && analytics);

    return (
      <div className={popupClassName}>
        <h2 className="cookie-settings-popup__title">
          {lczStrings.popup_heading}
        </h2>
        <p className="cookie-settings-popup__description">
          {lczStrings.popup_description}
          {' '}
          <CookieNoticeLink
            target={infoTarget}
            rel="noopener noreferrer"
            className="cookie-settings-popup__description-link"
            href={infoUrl}
            disabled={disabledLinks}
            text={lczStrings['popup_read-about-cookies-link']}
          />
          .
        </p>

        <h3 className="cookie-settings-popup__subtitle">
          {lczStrings.popup_categories_heading}
        </h3>
        <div className="_mt--5">
          <div className="cookie-settings-popup__option-wrap">
            <h4 className="cookie-settings-popup__option-title">
              {lczStrings['popup_categories_essential-heading']}
            </h4>
            <CookieSettingsCheckbox
              checked
              disabled
              lczStrings={lczStrings}
            />
          </div>
          <p className="cookie-settings-popup__option-text">
            {lczStrings['popup_categories_essential-description']}
            {' '}
            <CookieNoticeLink
              target={infoTarget}
              rel="noopener noreferrer"
              className="cookie-settings-popup__description-link"
              href={infoUrl}
              disabled={disabledLinks}
              text={lczStrings['popup_privacy-policy-link']}
            />
            .
          </p>
        </div>

        {isFunctionalityVisible && (
          <div>
            <div className="cookie-settings-popup__option-wrap">
              <h4 className="cookie-settings-popup__option-title">
                {
                  lczStrings[
                    'popup_categories_functionality-heading'
                  ]
                }
              </h4>
              <CookieSettingsCheckbox
                checked={functionality}
                onChange={this.handleChange('functionality')}
                lczStrings={lczStrings}
              />
            </div>
            <p className="cookie-settings-popup__option-text">
              {
                lczStrings[
                  'popup_categories_functionality-description'
                ]
              }
            </p>
          </div>
        )}

        {isAnalyticsVisible && (
          <div>
            <div className="cookie-settings-popup__option-wrap">
              <h4 className="cookie-settings-popup__option-title">
                {
                  lczStrings[
                    'popup_categories_analytic-heading'
                  ]
                }
              </h4>
              <CookieSettingsCheckbox
                checked={analytics}
                onChange={this.handleChange('analytics')}
                lczStrings={lczStrings}
              />
            </div>
            <p className="cookie-settings-popup__option-text _pb-10">
              {
                lczStrings[
                  'popup_categories_analytic-description'
                ]
              }
            </p>
          </div>
        )}

        <div className="cookie-settings-popup__btn-wrap">
          {enabledAllowAll && (
            <button
              className="cookie-settings-popup__btn _empty"
              onClick={this.handleAllowAll}
              type="button"
            >
              {lczStrings['popup_allow-all-btn']}
            </button>
          )}
          <button
            className="cookie-settings-popup__btn"
            onClick={this.handleSave}
            type="button"
          >
            {lczStrings['popup_save-btn']}
          </button>
        </div>
      </div>
    );
  }
}

CookieSettingsPopup.propTypes = {
  lczStrings: PropTypes.object.isRequired,
  disabledLinks: PropTypes.bool,
  infoUrl: PropTypes.string,
  infoTarget: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  className: PropTypes.string,
  analytics: PropTypes.bool,
  functionality: PropTypes.bool,
  storage: PropTypes.shape({
    isEuro: PropTypes.bool,
    environment: PropTypes.string.isRequired,
  }),
};

CookieSettingsPopup.defaultProps = {
  infoUrl: '',
  className: '',
  infoTarget: '_blank',
  disabledLinks: false,
  analytics: false,
  functionality: false,
  storage: CookieManager,
};

export default CookieSettingsPopup;
